import React from "react";

/**
 * ButtonCount component.
 *
 * @module ButtonCount
 * @param {Object} props - Properties passed to component
 * @param {number} props.count - Count to display, default is 0
 * @returns {ReactNode} - ButtonCount component
 */
export default function ButtonCount(props) {
  const { count } = props;

  return (
    <span className="-my-0.5 -mr-0.5 rounded bg-black/10 px-1 py-0.5 text-xs">
      {count}
    </span>
  );
}
